// components/Header/MobileDrawer.jsx
import React from 'react';
import { Drawer, Box, MenuItem, Divider } from '@mui/material';
import { User, Package, Settings, LogOut } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../context/AuthContext';
import { UserInfo } from './UserInfo';
import { ThemeToggleMenuItem } from './ThemeToggle';
import { LanguageSwitcher } from '../LanguageSwitcher/LanguageSwitcher';
import { LocationSelector } from '../LocationSelector/LocationSelector';

export const MobileDrawer = ({ open, onClose }) => {
  const { t } = useTranslation();
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleNavigate = (path, state = {}) => {
    onClose();
    navigate(path, { state });
  };

  const handleLogout = async () => {
    onClose();
    try {
      await logout();
      navigate('/auth');
    } catch (error) {
      console.error('Error logging out:', error);
    }
  };

  const menuItems = [
    {
      label: t('myProfile') || 'Profile & Settings',
      icon: User,
      onClick: () => handleNavigate('/user/profile'),
    },
    {
      label: t('myOrders') || 'My Orders',
      icon: Package,
      onClick: () => handleNavigate('/user/orders'),
    },
    {
      label: t('settings.title') || 'Settings',
      icon: Settings,
      onClick: () => handleNavigate('/settings'),
    },
  ];

  return (
    <Drawer
      anchor="left"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          bgcolor: 'background.paper',
          width: 280,
        },
      }}
    >
      <Box sx={{ pt: 2 }}>
        {user && (
          <>
            <UserInfo variant="mobile" />
            <Divider />

            {menuItems.map((item) => {
              const Icon = item.icon;
              return (
                <MenuItem
                  key={item.label}
                  onClick={item.onClick}
                  sx={{
                    py: 1.5,
                    fontFamily: 'Inter, sans-serif',
                    fontWeight: 500,
                  }}
                >
                  <Icon size={20} style={{ marginRight: 12 }} />
                  {item.label}
                </MenuItem>
              );
            })}

            <Divider />
          </>
        )}

        {/* Theme Toggle */}
        <ThemeToggleMenuItem />

        <Divider />

        <Box sx={{ p: 2 }}>
          <LocationSelector fullWidth />
        </Box>

        <Box sx={{ p: 2 }}>
          <LanguageSwitcher fullWidth />
        </Box>

        {user && (
          <>
            <Divider />
            <MenuItem
              onClick={handleLogout}
              sx={{
                py: 1.5,
                color: 'error.main',
                fontFamily: 'Inter, sans-serif',
                fontWeight: 500,
              }}
            >
              <LogOut size={20} style={{ marginRight: 12 }} />
              {t('logout') || 'Logout'}
            </MenuItem>
          </>
        )}
      </Box>
    </Drawer>
  );
};